export const ArrowDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.40405 7.48474C6.58804 7.48474 6.77213 7.55496 6.91234 7.69541L9.99943 10.7813L13.087 7.69372C13.3679 7.41283 13.8229 7.41283 14.1038 7.69372C14.3847 7.97461 14.3847 8.42965 14.1038 8.71054L10.5084 12.3059C10.2275 12.5868 9.77247 12.5868 9.49158 12.3059L5.8962 8.71054C5.61531 8.42965 5.61531 7.97461 5.8962 7.69372C6.03552 7.5544 6.21978 7.48474 6.40405 7.48474Z"
        fill="white"
      />
    </svg>
  );
};

export const ChevronIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m4 6 4 4 4-4"
      ></path>
    </svg>
  );
};

export const SelectedIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m2 6 3 3 5-6" />
    </svg>
  );
};

export const CloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#fff"
        d="M14.144 5.216a.746.746 0 0 1 1.052 0c.29.29.29.759 0 1.048l-3.938 3.927 3.938 3.928c.29.29.29.76 0 1.049a.746.746 0 0 1-1.053 0l-3.938-3.928-3.936 3.926a.745.745 0 0 1-1.051 0 .74.74 0 0 1 0-1.05l3.935-3.925-3.935-3.925a.74.74 0 0 1 0-1.048.745.745 0 0 1 1.051 0l3.936 3.924z"
      ></path>
    </svg>
  );
};

export const MainBackground = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1920"
      height="1550"
      fill="none"
      viewBox="0 0 1920 1550"
    >
      <path fill="url(#paint0_radial_22119_9392)" d="M-100 139.812h2120v1410H-100z"></path>
      <g filter="url(#filter0_f_22119_9392)">
        <path
          stroke="url(#paint1_linear_22119_9392)"
          strokeLinecap="round"
          strokeOpacity="0.3"
          strokeWidth="432"
          d="m277 306.812 314 314 314 314"
        ></path>
      </g>
      <g filter="url(#filter1_f_22119_9392)">
        <path
          stroke="url(#paint2_linear_22119_9392)"
          strokeLinecap="round"
          strokeOpacity="0.1"
          strokeWidth="362.098"
          d="M1535.58 254.812 1329.5 489.037l-206.09 234.224"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint1_linear_22119_9392"
          x1="509.482"
          x2="863.786"
          y1="918.312"
          y2="806.124"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.062" stopOpacity="0"></stop>
          <stop offset="0.997" stopColor="#41E2F8"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_22119_9392"
          x1="1057.41"
          x2="1128.59"
          y1="392.555"
          y2="721.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.062" stopOpacity="0"></stop>
          <stop offset="0.997" stopColor="#41E2F8"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <filter
          id="filter0_f_22119_9392"
          width="1236"
          height="1236"
          x="-27"
          y="2.812"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_22119_9392" stdDeviation="44"></feGaussianBlur>
        </filter>
        <filter
          id="filter1_f_22119_9392"
          width="921.794"
          height="978.073"
          x="868.603"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_22119_9392" stdDeviation="36.88"></feGaussianBlur>
        </filter>
        <radialGradient
          id="paint0_radial_22119_9392"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 705 -1060 0 960 844.812)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004CFF"></stop>
          <stop offset="1" stopColor="#02070D" stopOpacity="0"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
};
